/** @format */

const template = `
<div ng-class="{'courseunit-substitution-group': $ctrl.substitution.length > 1 }">
  <article class="courseunit cu-color-{{$ctrl.colorIndex}}" ng-repeat="courseUnitSubstitution in $ctrl.substitution">
    <div class="courseunit-top-row">
      <div class="credits-box">
        <span class="credit-amount"> {{ courseUnitSubstitution._courseUnit.credits | creditRangeShort }} </span>
        <span class="credit-abbreviation" translate="STUDIES.COURSE_UNIT_INFO_MODAL.CREDITS_ABBREVIATION"></span> </div
      ><div class="title-box">
        <span class="courseunit-code">
          <button
            type="button"
            class="link-button"
            ng-click="$ctrl.openCourseUnitInfoModal(courseUnitSubstitution._courseUnit)"
            aria-label="{{ courseUnitSubstitution._courseUnit.code }} {{courseUnitSubstitution._courseUnit.name | localizedString}} {{'ARIA_LABEL.OPEN_INFO' | translate}}">
            <sis-icon icon="brochure"></sis-icon>{{ courseUnitSubstitution._courseUnit.code }}
          </button>
          <span
            ng-if="courseUnitSubstitution._courseUnit.documentState != 'ACTIVE'"
            class="tiny-badge"
            ng-class="{'accent': courseUnitSubstitution._courseUnit.documentState == 'DRAFT',
                                     'danger': courseUnitSubstitution._courseUnit.documentState == 'DELETED'}"
            translate="{{'DOCUMENT_STATE.' + courseUnitSubstitution._courseUnit.documentState}}">
          </span>
        </span>
        <span class="courseunit-title">{{ courseUnitSubstitution._courseUnit.name | localizedString}}</span> </div
      ><!--
--><ng-transclude
      ></ng-transclude>
    </div>
    <div ng-if="courseUnitSubstitution.credits" class="cu-notification-bar">
      <div class="cu-notification">
        <span class="cu-notification-header"><sis-icon icon="info"></sis-icon> </span
        ><span
          class="cu-notification-content"
          translate="STUDIES.SUBSTITUTION_EDITOR.SUBSTITUTED_CREDITS"
          translate-values="{ credits: courseUnitSubstitution.credits}">
        </span>
      </div>
    </div>
  </article>
</div>
`;
export default template;
